<script setup>
import {useI18n} from "vue-i18n";
import {computed} from "vue";

const { locale } = useI18n()

const services = computed(()=> [
  {
    id: 1,
    title: 'IT-Решения',
    icon: '/img/services/it.svg',
    text: 'Облачные и цифровые\nсервисы, аренда серверов,\nхостинг, IT-услуги',
    href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/it-resheniya?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'it',
    buttons: [
      { id: 1, label: 'Подробнее', href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/it-resheniya?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: true }
    ]
  },
  {
    id: 2,
    title: 'Маркировка',
    text: 'Маркировка кодом Data Matrix',
    icon: '/img/services/mark.svg',
    href: `https://tanba.telecom.kz/${locale.value === 'en' ? 'kk' : locale.value}/?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'marking',
    buttons: [
      { id: 1, label: 'Подробнее', href: `https://tanba.telecom.kz/${locale.value === 'en' ? 'kk' : locale.value}/?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: true },
      { id: 2, label: 'ЦЭДМ', href: 'https://edo.markirovka.kz/', primary: false, event: "ym(96365240,'reachGoal','click-business-services-marking-cedm')" },
      { id: 3, label: 'НКТ', href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/nct?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: false },
      { id: 4, label: 'НСПТ', href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/nspt?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: false },
      { id: 5, label: 'Track&Trace', href: `${import.meta.env.VITE_HOST}/${locale.value === 'en' ? 'kk' : locale.value}/track-trace?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: false }
    ]
  },
  {
    id: 3,
    title: 'ОФД',
    text: 'Решение для фискального учёта',
    icon: '/img/services/ofd.svg',
    href: 'https://oofd.kz/',
    className: 'ofd',
    event: "ym(96365240,'reachGoal','click-business-services-ofd')",
    buttons: [
      { id: 1, label: 'ОФД', href: 'https://oofd.kz/', primary: true, event: "ym(96365240,'reachGoal','click-business-services-ofd')" },
      { id: 2, label: 'Личный кабинет', href: 'https://org.oofd.kz/#/landing', primary: false, event: "ym(96365240,'reachGoal','click-business-services-ofd-lk')" },
      { id: 3, label: 'Документы', href: `${import.meta.env.VITE_HOST}/cabinet?lang=${locale.value}`, primary: false, event: "ym(96365240,'reachGoal','click-business-services-ofd-documents')" }
    ]
  },
  {
    id: 4,
    title: 'Telecom Link',
    text: 'Сервис сокращения ссылок',
    icon: '/img/services/link.svg',
    href: `https://link.telecom.kz/?lang=${locale.value}&utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'link',
    buttons: [
      { id: 1, label: 'Сократить ссылку', href: `https://link.telecom.kz/?lang=${locale.value}&utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: true }
    ]
  },
  {
    id: 5,
    title: 'Telecom Docs',
    text: 'Подписывайте,\nотправляйте\nи получайте\nдокументы онлайн',
    icon: '/img/services/docs.svg',
    href: `https://docs.telecom.kz?lang=${locale.value}&utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'docs',
    buttons: [
      { id: 1, label: 'Начать работу', href: `https://docs.telecom.kz/cabinet?lang=${locale.value}`, primary: true, event: "ym(96365240,'reachGoal','click-business-services-telecom-docs-start')" },
      { id: 2, label: 'О сервисе', href: `https://docs.telecom.kz?lang=${locale.value}&utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: false }
    ]
  },
  {
    id: 6,
    title: 'Al-Farabium',
    text: 'Облачная среда\nдля AI-технологий на базе\nNVIDIA H200',
    icon: '/img/services/alfar.svg',
    href: `${import.meta.env.VITE_HOST}/${locale.value}/al-farabium?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'ai',
    buttons: [
      { id: 1, label: 'Подробнее', href: `${import.meta.env.VITE_HOST}/${locale.value}/al-farabium?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: true }
    ]
  },
  {
    id: 7,
    title: 'Activation Hub',
    text: 'Поддержка стартапов\nи компаний',
    icon: '/img/services/hub.svg',
    href: `https://activation.telecom.kz/${locale.value}/?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'hub',
    buttons: [
      { id: 1, label: 'Подробнее', href: `https://activation.telecom.kz/${locale.value}/?utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: true }
    ]
  },
  {
    id: 8,
    title: 'Telecom Tap',
    text: 'Создайте свою link in bio\nстраницу',
    icon: '/img/services/tap.svg',
    href: `https://tap.telecom.kz/?lang=${locale.value}&utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`,
    className: 'tap',
    buttons: [
      { id: 1, label: 'Подробнее', href: `https://tap.telecom.kz/?lang=${locale.value}&utm_source=b2b-telecom&utm_medium=business_services&utm_campaign=main_page`, primary: true, event: "ym(48820577,'reachGoal','click-main-page-services-tap-telecom')" }
    ]
  }
])

const handleLinkClick = (button, target) => {
  if (button.event) {
    fireEvent(button.event);
  }
  const url = button.href || '#';
  if (url !== '#') {
    window.open(url, target);
  }
}

const fireEvent = (event) => {
  if (!event) return
  try {
    const execute = new Function(event)
    execute()
  } catch (error) {}
}
</script>

<template>
  <section class="business-services">
    <div class="business-services__inner">
      <div class="business-services__header">
        <h2 class="business-services__title">
          {{$t('Сервисы для бизнеса')}}
        </h2>
      </div>

      <div class="business-services__grid">
        <article
            v-for="service in services"
            :key="service.id"
            class="service-card"
            :class="`service-card--${service.className}`"
        >
          <div class="service-card__top">
            <div>
              <div class="service-card__wrapper"
                   @click.prevent="handleLinkClick(service, '_self')"
                   @mousedown.middle.prevent="handleLinkClick(service, '_blank')">
                <h3 class="service-card__title">
                  {{ $t(service.title) }}
                </h3>
              </div>
              <p class="service-card__text">
                {{ $t(service.text) }}
              </p>
            </div>

            <a :href="service.href"
                v-if="service.icon"
                class="service-card__icon"
                type="button"
            >
              <img :src="service.icon" :alt="$t(service.title)">
            </a>
          </div>

          <div v-if="service.buttons?.length" class="service-card__actions">
            <template v-if="service.className === 'ofd'">
              <div class="service-card__actions__ofd">
                <template v-for="button in service.buttons">
                  <div :key="button.id"
                          class="service-card__button service-card__button--primary"
                          type="button"
                          v-if="button.primary"
                       @click.prevent="handleLinkClick(button, '_self')"
                       @mousedown.middle.prevent="handleLinkClick(button, '_blank')">
                    {{ $t(button.label) }}
                  </div>
                </template>
              </div>
              <template v-for="button in service.buttons">
                <div :key="button.id"
                   class="service-card__button"
                   type="button"
                   v-if="!button.primary"
                     @click.prevent="handleLinkClick(button, '_self')"
                     @mousedown.middle.prevent="handleLinkClick(button, '_blank')">
                  {{ $t(button.label) }}
                </div>
              </template>
            </template>
            <div v-else
                v-for="button in service.buttons"
                :key="button.id"
                class="service-card__button"
                :class="{ 'service-card__button--primary': button.primary }"
                type="button"
                 @click.prevent="handleLinkClick(button, '_self')"
                 @mousedown.middle.prevent="handleLinkClick(button, '_blank')">
              {{ $t(button.label) }}
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.business-services {
  width: 100%;
  background: #f4f5f7;
  padding: 80px 0;
  box-sizing: border-box;

  &__inner {
    max-width: 1280px;
    margin: 0 auto;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 32px;
  }

  &__title {
    margin: 0;
    font-size: 36px;
    line-height: 1.15;
    font-weight: 600;
    color: $primary-dark;
  }

  &__all {
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 16px;
    line-height: 1;
    color: $primary-dark;
    text-decoration: none;
    transition: background-color 0.2s ease;

    &:hover {
      background: $color-primary;
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(14, 1fr);
    grid-template-rows: 192px 112px 222px 200px;
    gap: 16px;
  }
}

.service-card {
  position: relative;
  overflow: hidden;
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  box-sizing: border-box;
  box-shadow: 0 7px 16px 0 rgba(28, 43, 64, 0.04);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
  height: 100%;
  min-height: 0;
  &--ofd,
  &--link
  {
    .service-card__icon {
      left: 32px;
    }
  }
  &:hover {
    .service-card__actions {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }

  &--ofd,
  &--link,
  &--docs,
  &--ai {
    &:hover {
      .service-card__icon {
        display: none;
      }
    }
  }

  &__wrapper {
    text-decoration: none;
  }

  &__top {
    height: 100%;
  }

  &__title {
    width: fit-content;
    margin: 0 0 14px;
    font-size: 28px;
    line-height: 28px;
    font-weight: 600;
    color: $primary-dark;
    cursor: pointer;
    transition: color 0.2s ease;
  }

  &__text {
    max-width: 285px;
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    color: #495057;
    white-space: pre-line;
  }

  &__icon {
    width: 56px;
    height: 56px;
    padding: 0;
    border: none;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: absolute;
    right: 32px;
    bottom: 32px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  &__actions {
    position: absolute;
    left: 34px;
    right: 34px;
    bottom: 29px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 7px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(6px);
    transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
    &__ofd {
      flex-basis: 100%;
    }
  }

  &__button {
    min-height: 29px;
    padding: 6px 12px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #CED4DA;
    color: $primary-dark;
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
    cursor: pointer;
    transition: color 0.2s ease, background-color 0.2s ease;
    text-decoration: none;
    width: max-content;
    &:hover {
      background: #F9F9F9;
      border-color: #CED4DA;
      color: $primary-dark;
    }

    &--primary {
      background: $primary-blue;
      border: 1px solid $primary-blue;
      color: $color-primary;
      &:hover {
        background: #0076DA;
        border: 1px solid #0076DA;
        color: $color-primary;
      }
    }
  }

  &--it {
    grid-column: 1 / 9;
    grid-row: 1 / 3;
    .service-card__icon {
      top: 34px;
      bottom: auto;
    }
  }

  &--marking {
    grid-column: 9 / 15;
    grid-row: 1 / 2;
    .service-card__icon {
      top: 34px;
      bottom: auto;
    }
  }

  &--ofd {
    grid-column: 1 / 5;
    grid-row: 3 / 4;
  }

  &--link {
    grid-column: 5 / 9;
    grid-row: 3 / 4;
  }

  &--docs {
    grid-column: 9 / 12;
    grid-row: 2 / 4;
  }

  &--ai {
    grid-column: 12 / 15;
    grid-row: 2 / 4;
  }

  &--hub {
    grid-column: 1 / 8;
    grid-row: 4 / 5;
  }

  &--tap {
    grid-column: 8 / 15;
    grid-row: 4 / 5;
  }

  &--docs,
  &--ai {
    .service-card__actions {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  &--it,
  &--hub,
  &--tap {
    .service-card__actions {
      margin-right: 56px;
    }
  }
}

@media (max-width: 1440px) {
  .business-services{
    padding: 80px;
    &__grid {
      grid-template-rows: 220px 112px 280px 200px;
    }
  }
}

@media (max-width: 1024px) {
  .business-services {
    padding: 64px 80px;
    &__title {
      font-size: 32px;
    }
    &__grid {
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(4, 200px);
      grid-auto-rows: 200px;
    }
    .service-card {
      &__actions {
        flex-direction: row;
        left: 24px;
        right: 24px;
        bottom: 24px;
        &__ofd {
          flex-basis: auto;
        }
      }
      &__text {
        white-space: normal;
      }
      &--it,
      &--marking,
      &--ofd,
      &--link,
      &--docs,
      &--ai,
      &--hub,
      &--tap {
        padding: 24px;
        grid-column: span 1;
        grid-row: span 1;
        .service-card__icon {
          top: 24px;
          left: auto;
          right: 24px;
          bottom: 24px
        }
        &:hover {
          .service-card__icon {
            display: block;
          }

        }
      }
    }
  }
}

@media (max-width: 900px) {
  .business-services {
    display: none;
  }
}
</style>
